import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations';
import actions from './actions';
import getters from './gettets';


Vue.use(Vuex);

let mode = window.calc_mode || 'default';

export default new Vuex.Store({
    strict : process.env.NODE_ENV !== 'production',
    state: {
        // mode: 'default',
        mode: mode,
        products: [],
        steps: [],
        criteria: [],
        selectedCriteria: {
            //roof
            roofing_material : 'metalic',
            roofing_lenght : '',
            heating_width : '',

            //drain
            chute_total_length: '',
            drain_height : '',
            drain_height_2 : '',
            drain_height_3 : '',
            drain_height_4 : '',
            drain_height_5 : '',

            //pavement
            heating_appointment : 'open_area',
            insulation_presence : '0',
            heating_square : '',

        },
    },
    mutations,
    actions,
    getters,

})

